import React from "react";
import {
  ShimmerTable,
  ShimmerButton,
  ShimmerTitle,
  ShimmerText,
  ShimmerThumbnail,
} from "react-shimmer-effects";

const FirstLastTouchLoading = () => {
  return (
    <div className="p-5 bg-gray-100 min-h-screen" style={{ width:"78%" }}>
      <div className="bg-white p-4 shadow rounded-lg mb-4">
        <div className="flex justify-between items-center mb-4">
          <ShimmerTitle line={1} />
          <div className="flex gap-3">
            <ShimmerButton size="md" />
            <ShimmerThumbnail width={100} height={40} rounded />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <ShimmerText line={1} />
          <ShimmerText line={1} />
        </div>
        <ShimmerTable row={5} col={3} />
      </div>
    </div>
  );
};

export default FirstLastTouchLoading;
